import { IPurchaseHistory } from "../../PurchaseHistory/IPurchaseHistory";

export const CURRENCY_STRINGS: Record<IPurchaseHistory.ICurrencyCode, string> =
  {
    INR: "INR",
    USD: "USD",
    EUR: "EUR",
    GBP: "GBP",
    CAD: "CAD",
    AED: "AED",
    AUD: "AUD",
    IDR: "IDR",
    SAR: "SAR",
    ARS: "ARS",
    TTD: "TTD",
    NGN: "NGN",
    PKR: "PKR",
    MUR: "MUR",
    MMK: "MMK",
    EGP: "EGP",
    HUF: "HUF",
    ZAR: "ZAR",
    PHP: "PHP",
    THB: "THB",
    SGD: "SGD",
    KHR: "KHR",
    LAK: "LAK",
    BDT: "BDT",
    MYR: "MYR",
  };

// Define the structure for the currency symbols
export const CURRENCY_SYMBOLS: Record<IPurchaseHistory.ICurrencyCode, string> =
  {
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
    CAD: "CA$",
    AED: "AED",
    AUD: "AU$",
    IDR: "Rp",
    SAR: "SR",
    ARS: "AR$",
    TTD: "TT$",
    NGN: "NGN",
    PKR: "PKRs",
    MUR: "MURs",
    MMK: "K",
    EGP: "EGP",
    HUF: "Ft",
    ZAR: "R",
    PHP: "PHP",
    THB: "THB",
    SGD: "S$",
    KHR: "KHR",
    LAK: "LAK",
    BDT: "Tk",
    MYR: "RM",
  };

export const PAYMENT_DEBIT_MODES = {
  PAYMENT_LINKS: 1,
  AUTO_DEBIT: 2,
};

export const payment_login_api = "users/exly/multiple/login";
export const listing_availability_api = "host/listing/availability";
export const initiate_payment_api = "payments/order/initiate";
